export default {
  methods: {
    monthsAndYears(months) {
      const yearsNumber = this.$i18n.n(Math.floor(months / 12), 'decimal')
      const yearsUnit = Number(yearsNumber) === 1 ? this.$i18n.t('partials.time.year') : this.$i18n.t('partials.time.years')
      const monthsNumber = this.$i18n.n(months % 12, 'decimal')
      const monthsUnit = months % 12 === 1 ? this.$i18n.t('partials.time.month') : this.$i18n.t('partials.time.months')
      return `${yearsNumber} ${yearsUnit} ${monthsNumber} ${monthsUnit}`
    },
    days(days) {
      const dayDays = Number(days) === 1 ? this.$i18n.t('partials.time.day') : this.$i18n.t('partials.time.days')
      return `${this.$n(days, 'decimal')} ${dayDays}`
    },
    dateFromIso(isoStringUTC) {
      if (typeof isoStringUTC === 'string') {
        const dateArgsUTC = {
          y: isoStringUTC.slice(0, 4),
          m: Number(isoStringUTC.slice(5, 7)) - 1,
          d: isoStringUTC.slice(8, 10)
        }
        const dateObj = new Date(dateArgsUTC.y, dateArgsUTC.m, dateArgsUTC.d)
        return this.$i18n.d(dateObj, 'short')
      }
      else {
        return null
      }
    }
  }
}
